import React from 'react'
import Button from '../../../ui/Button/Button'
import BlogArticleView from '../article/BlogArticleView'
import styles from './BlogVersionConflict.module.scss'

export default function BlogVersionConflict({ conflict, isSaving, onResolve, onDownload }) {
  const { remote, localRevision } = conflict
  const savedAt = remote.draftSavedAt || remote.draft?.contentSavedAt
  return (
    <section className={styles.panel} aria-label="Версії статті">
      <p>
        <strong>Версії статті відрізняються</strong>
      </p>
      <p>
        У редакторі — ваш локальний чернетковий текст (версія {localRevision}). На сервері — версія{' '}
        {remote.draftRevision}
        {savedAt ? `, збережена ${new Date(savedAt).toLocaleString('uk-UA')}` : ''}.
      </p>
      <details className={styles.preview}>
        <summary>Переглянути серверну версію</summary>
        <div className={styles.article}>
          {remote.draft?.cover?.imageUrl ? (
            <img className={styles.cover} src={remote.draft.cover.imageUrl} alt="Обкладинка серверної версії" />
          ) : null}
          <p>{remote.draft?.excerpt}</p>
          <BlogArticleView title={remote.draft?.title || remote.title} blocks={remote.draft?.blocks} />
        </div>
      </details>
      <p>Перед заміною завантажиться резервна копія обох версій. Переконайтеся, що браузер зберіг файл.</p>
      <div className={styles.actions}>
        <Button theme="bounded" onClick={onDownload} disabled={isSaving}>
          Завантажити обидві версії
        </Button>
        <Button theme="bounded" onClick={() => onResolve('remote')} disabled={isSaving}>
          Відкрити серверну версію в редакторі
        </Button>
        <Button theme="solid" onClick={() => onResolve('local')} isLoading={isSaving}>
          Зберегти мої зміни замість серверної версії
        </Button>
      </div>
    </section>
  )
}
